import _isEqual from "lodash/isEqual";
export const updatePatch = (initialValue, newValue, path, patches) => {
  if (initialValue) {
    if (newValue && !_isEqual(initialValue, newValue)) {
      patches.push({
        op: 'replace',
        path,
        value: newValue
      });
    } else if (!newValue) {
      patches.push({
        op: 'remove',
        path
      });
    }
  } else if (newValue) {
    patches.push({
      op: 'add',
      path,
      value: newValue
    });
  }
};
export const getPartnerContactInfoUpdatePayload = _ref => {
  let {
    name,
    email,
    line1,
    line2,
    city,
    state,
    country,
    postCode,
    homePage,
    phone,
    otherContactDetails,
    initialPartnerName,
    initialPartnerEmail,
    initialAddressLine1,
    initialAddressLine2,
    initialCity,
    initialState,
    initialCountry,
    initialPostCode,
    initialHomePage,
    initialPhone,
    initialOtherContactDetails
  } = _ref;
  const patches = [];
  updatePatch(initialPartnerName, name, '/name', patches);
  updatePatch(initialPartnerEmail, email, '/email', patches);
  updatePatch(initialAddressLine1, line1, '/address/line1', patches);
  updatePatch(initialAddressLine2, line2, '/address/line2', patches);
  updatePatch(initialCity, city, '/address/city', patches);
  updatePatch(initialState, state, '/address/state', patches);
  updatePatch(initialCountry, country.name, '/address/country', patches);
  updatePatch(initialPostCode, postCode, '/address/postCode', patches);
  updatePatch(initialHomePage, homePage, '/vendorLinks/homePage', patches);
  updatePatch(initialPhone, phone, '/phone', patches);
  updatePatch(initialOtherContactDetails, otherContactDetails, '/otherContactDetails', patches);
  return patches;
};
export const getAboutPartnerUpdatePayload = _ref2 => {
  let {
    initialDescription,
    initialLogoUrl,
    description,
    logoUrl
  } = _ref2;
  const patches = [];
  updatePatch(initialDescription, description, '/description', patches);
  updatePatch(initialLogoUrl, logoUrl, '/_links/logo/href', patches);
  return patches;
};
export const getSupportChannelsUpdatePayload = _ref3 => {
  let {
    initialSupportOrganizationName,
    initialSupportUrl,
    initialSupportEmail,
    initialSupportPhone,
    initialEmergencyContact,
    supportOrganizationName,
    supportUrl,
    supportEmail,
    supportPhone,
    emergencyContact
  } = _ref3;
  const patches = [];
  updatePatch(initialSupportOrganizationName, supportOrganizationName, '/supportDetails/supportOrg/name', patches);
  updatePatch(initialSupportUrl, supportUrl, '/supportDetails/supportOrg/supportUrl', patches);
  updatePatch(initialSupportEmail, supportEmail, '/supportDetails/supportOrg/supportEmail', patches);
  updatePatch(initialSupportPhone, supportPhone, '/supportDetails/supportOrg/supportPhone', patches);
  updatePatch(initialEmergencyContact, emergencyContact, '/supportDetails/emergencyContact', patches);
  return patches;
};